import _classCallCheck from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
/* eslint-disable no-restricted-syntax */
import { Point2D } from "kld-affine";
import ShapeInfo from "./ShapeInfo.js";
var SvgShapes = /*#__PURE__*/function () {
  function SvgShapes() {
    _classCallCheck(this, SvgShapes);
  }
  _createClass(SvgShapes, null, [{
    key: "circle",
    /**
     * circle
     *
     * @param {SVGCircleElement} circle
     * @returns {module:kld-intersections.ShapeInfo}
     */
    value: function circle(_circle) {
      if (_circle instanceof SVGCircleElement === false) {
        throw new TypeError("Expected SVGCircleElement, but found ".concat(_circle));
      }
      var center = new Point2D(_circle.cx.baseVal.value, _circle.cy.baseVal.value);
      var radius = _circle.r.baseVal.value;
      return ShapeInfo.circle(center, radius);
    }
    /**
     * ellipse
     *
     * @param {SVGEllipseElement} ellipse
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "ellipse",
    value: function ellipse(_ellipse) {
      if (_ellipse instanceof SVGEllipseElement === false) {
        throw new TypeError("Expected SVGEllipseElement, but found ".concat(_ellipse));
      }
      var center = new Point2D(_ellipse.cx.baseVal.value, _ellipse.cy.baseVal.value);
      var radiusX = _ellipse.rx.baseVal.value;
      var radiusY = _ellipse.ry.baseVal.value;
      return ShapeInfo.ellipse(center, radiusX, radiusY);
    }
    /**
     * line
     *
     * @param {SVGLineElement} line
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "line",
    value: function line(_line) {
      if (_line instanceof SVGLineElement === false) {
        throw new TypeError("Expected SVGLineElement, but found ".concat(_line));
      }
      var p1 = new Point2D(_line.x1.baseVal.value, _line.y1.baseVal.value);
      var p2 = new Point2D(_line.x2.baseVal.value, _line.y2.baseVal.value);
      return ShapeInfo.line(p1, p2);
    }
    /**
     * path
     *
     * @param {SVGPathElement} path
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "path",
    value: function path(_path) {
      if (_path instanceof SVGPathElement === false) {
        throw new TypeError("Expected SVGPathElement, but found ".concat(_path));
      }
      var pathData = _path.getAttributeNS(null, "d");
      return ShapeInfo.path(pathData);
    }
    /**
     * polygon
     *
     * @param {SVGPolygonElement} polygon
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "polygon",
    value: function polygon(_polygon) {
      if (_polygon instanceof SVGPolygonElement === false) {
        throw new TypeError("Expected SVGPolygonElement, but found ".concat(_polygon));
      }
      var points = [];
      for (var i = 0; i < _polygon.points.numberOfItems; i++) {
        var point = _polygon.points.getItem(i);
        points.push(new Point2D(point.x, point.y));
      }
      return ShapeInfo.polygon(points);
    }
    /**
     * polyline
     *
     * @param {SVGPolylineElement} polyline
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "polyline",
    value: function polyline(_polyline) {
      if (_polyline instanceof SVGPolylineElement === false) {
        throw new TypeError("Expected SVGPolylineElement, but found ".concat(_polyline));
      }
      var points = [];
      for (var i = 0; i < _polyline.points.numberOfItems; i++) {
        var point = _polyline.points.getItem(i);
        points.push(new Point2D(point.x, point.y));
      }
      return ShapeInfo.polyline(points);
    }
    /**
     * rect
     *
     * @param {SVGRectElement} rect
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "rect",
    value: function rect(_rect) {
      if (_rect instanceof SVGRectElement === false) {
        throw new TypeError("Expected SVGRectElement, but found ".concat(_rect));
      }
      return ShapeInfo.rectangle(_rect.x.baseVal.value, _rect.y.baseVal.value, _rect.width.baseVal.value, _rect.height.baseVal.value, _rect.rx.baseVal.value, _rect.ry.baseVal.value);
    }
    /**
     * element
     *
     * @param {SVGElement} element
     * @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "element",
    value: function element(_element) {
      if (_element instanceof SVGElement === false) {
        throw new TypeError("Expected SVGElement, but found ".concat(_element));
      }

      /* eslint-disable-next-line prefer-destructuring */
      var tagName = _element.tagName;
      switch (tagName) {
        case "circle":
          return SvgShapes.circle(_element);
        case "ellipse":
          return SvgShapes.ellipse(_element);
        case "line":
          return SvgShapes.line(_element);
        case "path":
          return SvgShapes.path(_element);
        case "polygon":
          return SvgShapes.polygon(_element);
        case "polyline":
          return SvgShapes.polyline(_element);
        case "rect":
          return SvgShapes.rect(_element);
        default:
          throw new TypeError("Unrecognized element type: '".concat(tagName, "'"));
      }
    }
  }]);
  return SvgShapes;
}();
export default SvgShapes;